





























































import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'
import AudienceCreativeDisplay from '@ui/AudienceCreative/AudienceCreativeDisplay'
import PricingTable from '@ui/Event/PricingTable'
import UpdatePricingModelTriggerModal from '@triggers/Event/UpdatePricingModelTriggerModal'
import SuperNotes from '@modules/ui/notes/SuperNotes'

settings =
  name: 'AudienceCreativeShow'

  resources:
    audience_creative:
      resourceName: 'audience_creative'
      slug: 'audience_creatives/:audienceCreativeId'

  components: {
    LoadingIndicator,
    AudienceCreativeDisplay,
    PricingTable,
    UpdatePricingModelTriggerModal,
    SuperNotes
  }

  vue:
    data: ->
      modal:
        show: true

    computed:
      member: -> @$store.member
      supplierId: -> @member.supplier?.id

      draftCount: ->
        @audience_creative?.stats?.draft_availabilities_count

      publishedCount: ->
        @audience_creative?.stats?.published_availabilities_count

      actionsForPricingModel: ->
        hiUpdatePricingModelTrigger: @hiUpdatePricingModelTrigger
        hiRemoveSpecialPricingTrigger: @hiRemoveSpecialPricingTrigger

    methods:
      hiNavToEditStep: (step) ->
        params = { audienceCreativeId: @audience_creative.id }
        query = { step }
        @$router.push { name: 'AudienceCreativeEditPage', params, query }

      hiDeactivate: ->
        @triggerResource 'audience_creative', 'deactivate'
      hiReactivate: ->
        @triggerResource 'audience_creative', 'reactivate'

      hiTrust: ->
        @triggerResource 'audience_creative', 'trust'
      hiUntrust: ->
        @triggerResource 'audience_creative', 'untrust'

      hiUpdatePricingModelTrigger: (pricingModel, pricing) ->
        payloadOptions = { pricing_model: pricingModel }
        modalOptions = { pricing_model: pricingModel, pricing }
        @$refs.updatePricingModelTrigger.fire payloadOptions, modalOptions
      hiRemoveSpecialPricingTrigger: (pricingModel) ->
        @triggerResource 'audience_creative', 'update_pricing_model', { pricing_model: pricingModel }
      onAudienceCreativeUpdatePricingModel: (data, response) ->
        @$refs.updatePricingModelTrigger.close()
        @fetch 'audience_creative'

      hiAddSuperNote: ->
        note = @audience_creative.new_super_notes[0]
        @triggerResource 'audience_creative', 'add_super_note', { note }

export default VueOptions.vue settings
